import {useState} from "react";
import Modal from "./modal";
import JobLocation from "../jobLocation";

export default (props) => {
    const [showModal, setShowModal] = useState(false);
    const edit = (event) => {
        event.preventDefault();
        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(false).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };
    return (
        <div className="col-md-12 col-xl-12">
            <div className="card">
                {
                    showModal && <Modal label={"Shift Location"} showHide={edit} saveFunction={save}>
                        <JobLocation errors={props.errors}/>
                    </Modal>
                }
                <div className="col-lg-12 col-md-12">
                    <div className="row">
                        <div className="card-header">
                            <b><h5 className="mb-0">Location Info</h5></b>
                            {
                                props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                                    <i className="fe fe-edit" title="Edit Location Info"></i>
                                </a>
                            }
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="form-group">
                        <div className="row">
                        {
                            props?.employerJobLocationsList?.map(location => (
                                <>  <div className="col-lg-4 col-md-4">
                                    <label className="form-label">Location Name</label>
                                    <label htmlFor="Location Name">{location?.locationName}</label>
                                </div>
                                    <div className="col-lg-4 col-md-4">
                                        <label className="form-label">Address</label>
                                        <label htmlFor="Address">{location?.streetAddress}</label>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <label className="form-label">City</label>
                                        <label htmlFor="City">{location.city}</label>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <label className="form-label">State</label>
                                        <label htmlFor="State">{location?.stateName}</label>
                                    </div>
                                    {/* <div className="col-lg-4 col-md-4">
                                        <label className="form-label">Country</label>
                                        <label htmlFor="Country">{location?.country}</label>
                                    </div> */}
                                </>
                            ))
                        }
                         {
                            <div className="col-lg-4 col-md-4">
                                <label className="form-label">Contact persons</label>
                                {
                                    <label htmlFor="Location Name">{
                                        props?.contactList?.map(contact => (contact.name)).join(", ")
                                    } </label>
                                }
                            </div>

                        }
                        {
                            <div className="col-lg-4 col-md-4">
                                <label className="form-label">Approval users</label>
                                {
                                    <label htmlFor="Location Name">{
                                        props?.approverList?.map(contact => (contact.name)).join(", ")
                                    } </label>
                                }
                            </div>

                        }
                        </div>
                       
                       
                        
                    </div>
                </div>
            </div>
        </div>
    )
}
